import React from 'react';
import './App.css';
import 'antd/dist/reset.css';
import { Routes, Route, Navigate } from 'react-router-dom'; // No Router here
import LoginPage from './pages/LoginPage';
import CreateUserPage from './pages/CreateUserPage';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './ProtectedRoute';
import { AuthProvider } from './AuthContext';
import GoalsPage from './pages/ManageGoalsPage';
import UserAttributesUpdate from './pages/UserAttributesPage';
import ActivitiesPage from './pages/ManageActivities';
import TrackWeightsPage from './pages/ManageWeight';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RecipeForm from './pages/RecipePage';
import RecipeListPage from './pages/RecipeList';


function App() {
  

  return (
    <AuthProvider>
      <>
  
        <Routes>
          {/* Public Routes */}
          <Route path="/ui/login" element={<LoginPage />} />
          <Route path="/ui/user/create" element={<CreateUserPage />} />
          <Route path="/ui/user/password" element={<ForgotPasswordPage />} />
          <Route path="/ui/user/password/reset" element={<ResetPasswordPage />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/ui/dashboard" element={<Dashboard />} />
            <Route path="/ui/goal" element={<GoalsPage />} />
            <Route path="/ui/activity" element={<ActivitiesPage />} />
            <Route path="/ui/weight" element={<TrackWeightsPage />} />
            <Route path="/ui/user/attributes" element={<UserAttributesUpdate />} />
            <Route path="/ui/recipe" element={<RecipeForm />} />
            <Route path="/ui/recipe/:recipeId" element={<RecipeForm />} />
            <Route path="/ui/recipe/list" element={<RecipeListPage />} />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/ui/login" replace />} />
        </Routes>
      </>
    </AuthProvider>
  );
}

export default App;
